import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, map, mergeMap, of, switchMap } from 'rxjs'
import * as CountryActions from './country.actions'
import { CountryService } from '../../services/country.service'
import { loadCountries, loadCountryFailure } from './country.actions'

export const loadCountries$ = createEffect(
  (actions$ = inject(Actions), countryService = inject(CountryService)) =>
    actions$.pipe(
      ofType(loadCountries),
      switchMap(() =>
        countryService.getCountries().pipe(
          map(response => CountryActions.loadCountriesSuccess({ countries: response.countries })),
          catchError(error => of(loadCountryFailure({ error: error.message })))
        )
      )
    ),
  { functional: true }
)

export const countryEffects = { loadCountries$ }
